import Button from 'components/button'
import useRouter from 'hooks/use-router'
import textServices from 'services/text-services'
import ButtonCloseMenu from 'components/button-close'

interface IProps {
  setShowIntroduction: (show: boolean) => void
}

function IntroductionTrivia({ setShowIntroduction }: IProps) {

  const { history } = useRouter()

  const closeIntroduction = () => {
    localStorage.setItem('introductionTrivias', 'true')
    setShowIntroduction(false)
  }

  return (
    <div className="w-full flex-1 pb-8 flex flex-col">
      <ButtonCloseMenu
        open={true}
        paramFn={() => history.goBack()}
      />
      {textServices.findByText('trivia/modal/items', <img src={`${AZURE_BASE_URL}/popup-trivias-mobile.svg`} className="w-full" />)}
      <div className='px-8 flex flex-col items-center gap-4'>
        <Button onClick={closeIntroduction}>
          {textServices.findByText('trivia/introduction', { es: 'PARTICIPA AQUÍ', en: 'PARTICIPATE HERE' })}
        </Button>
        <button type="button" className="cursor-pointer" onClick={() => history.goBack()}>
          <p
            className={`din text-center uppercase underline`}
            style={{ fontSize: 10 }}
          >
            {textServices.findByText('backButton', { es: 'VOLVER', en: 'BACK TO' })}
          </p>
        </button>
      </div>
    </div>
  )
}

export default IntroductionTrivia